import React from "react";

const ToggleSwitch = ({
  checked = false,
  onChange,
  id = "toggle-switch",
  dataTestId = "toggle-switch",
}) => {
  return (
    <div id={id} data-testid={dataTestId}>
      <label className="switch" onChange={onChange}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span className="slider"></span>
      </label>
    </div>
  );
};

export default ToggleSwitch;
